import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

function initBoxSliders() {
    document.querySelectorAll('.block-box-slider .box-slider-slides').forEach((el) => {
        const paginationEl = el.querySelector('.box-slider-pagination .swiper-pagination');
        if (!paginationEl) return;

        new Swiper(el, {
            modules: [Pagination, Autoplay],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: el.querySelectorAll('.swiper-slide').length > 1,
            pagination: {
                el: paginationEl,
                clickable: true,
            },
            autoplay: {
                delay: 10000,
                disableOnInteraction: false,
            },
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBoxSliders);
} else {
    initBoxSliders();
}
